<template>
    <!-- 头部 logo 电话 邮件 -->
    <div style="overflow: hidden;">
        <!-- PC头部 -->
        <div class="header" :class="nowPage.indexOf('product-detail') != -1 ? 'header2' : ''">
            <div class="head" :class="nowPage.indexOf('product-detail') != -1 ? 'head2' : ''"
                :style="{ 'background': $store.state.scrollTop > 30 ? 'rgba(17,20,22,.75)' : 'none' }">
                <div class="headerTop">
                    <div class="logoBox" @click="goHome" style="margin-top: 10px;">
                        <div class="logo">
                            <img src="../assets/foot/logo.png" alt="">
                        </div>
                        <div class="logoText">
                            <!-- <p>河南庆荣发金属材料有限公司</p> -->
                            <!-- <p style="text-align: center;">
                            QRF ALLOY <br>MANUFACTURER
                        </p> -->
                            <img src="../assets/textlogo.png" alt="">
                            <!-- <p>Henan Qingrongfa metal material Co. LTD</p> -->
                        </div>
                    </div>
                    <div class="infoBox">
                        <div class="infoList cursor">
                            <div class="icon">
                                <img src="../assets/foot/phone.png" alt="">
                            </div>
                            <p class="textHover">
                                <span v-for="(item, index) in $store.state.navInfo.Tel" :key="index">
                                    <!-- 'tel:' + e -->
                                    <a v-for="(e, i) in (api.strToarr(item))" :key="i"
                                        :href="`https://api.whatsapp.com/send/?phone=%2B8613598128846&text&type=phone_number&app_absent=0`"
                                        class="clicka bigSize" style="display: block;">{{ e }}</a>
                                </span>
                            </p>
                        </div>
                        <div class="infoList cursor">
                            <div class="icon">
                                <img src="../assets/foot/emil.png" alt="">
                                <!-- <img src="../assets/home/email.png" alt=""> -->
                            </div>
                            <p class="textHover">
                                <span v-for="(item, index) in $store.state.navInfo.Email" :key="index">
                                    <a :href="'mailto:' + item" target="_blank" class="clicka bigSize">{{ item
                                        }}</a><br>
                                </span>
                            </p>
                        </div>
                        <div class="languageBox cursor">
                            <el-dropdown @command="handCommand">
                                <span class="el-dropdown-link">
                                    <div class="languageImg">
                                        <img :src="$store.state.nowstrLanguage.icon" alt="">
                                    </div>
                                    Language
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-for="(item, index) in $store.state.LangTypeList" :command="item"
                                        :key="index">
                                        <div style="display: flex;align-items: center;">
                                            <img style="width: 30px;height: 15px;margin-right: 10px;" :src="item.icon"
                                                alt="">
                                            <p>{{ item.label }}</p>
                                        </div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </div>
                <div class="menuBox">
                    <div class="menu" style="flex-shrink: 0;">
                        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
                            <template v-for="(item, index) in $store.state.menuData">
                                <el-menu-item v-if="item.child.length == 0" :index="item.link">
                                    <router-link :to="item.link">
                                        {{ item.name }}
                                    </router-link>
                                </el-menu-item>
                                <el-submenu v-else :index="item.link">
                                    <template slot="title">
                                        <router-link :to="item.link">
                                            {{ item.name }}
                                        </router-link>
                                    </template>
                                    <el-menu-item v-for="(e, i) in item.child" :index="item.link" :key="i">
                                        <div :class="e.name == detailTitle || e.id == detailId ? 'active2025' : ''">
                                            <router-link :to="e.link">
                                                {{ e.name }}
                                            </router-link>
                                        </div>
                                    </el-menu-item>
                                </el-submenu>
                            </template>
                        </el-menu>
                    </div>
                    <div class="searchBox">
                        <div class="icon" @click="searchInput">
                            <img src="../assets/home/search.png" alt="">
                        </div>
                        <input type="text" :placeholder="i18n.home.keyword" v-model="keyword"
                            @keyup.enter="searchInput">
                    </div>
                </div>
            </div>
        </div>
        <!-- H5头部 -->
        <div class="headerH">
            <div class="headH" :style="{ 'background': $store.state.scrollTop > 30 ? 'rgba(17,20,22,.75)' : 'none' }">
                <div class="logoBox cursor" @click="goHome">
                    <div class="logo">
                        <img src="../assets/foot/logo.png" alt="">
                    </div>
                    <div class="logoText">
                        <img src="../assets/textlogo.png" style="width: 140px;height: 35px;" alt="">
                        <!-- <p style="text-align: center;">
                        QRF ALLOY <br>MANUFACTURER
                    </p> -->
                        <!-- <p>QRF ALLOY MANUFACTURER</p> -->
                        <!-- <p>Henan Qingrongfa metal material Co. LTD</p> -->
                    </div>
                </div>
                <div class="setBox">
                    <div class="searchmenu">
                        <div class="searchBox cursor" @click="dialogVisible = true">
                            <img src="../assets/home/search.png" alt="">
                        </div>
                        <div class="menuIcon cursor" @click="drawer = true">
                            <!-- el-icon-s-unfold el-icon-s-operation -->
                            <i class="el-icon-s-operation"></i>
                        </div>
                    </div>

                    <div class="languageBox cursor">
                        <el-dropdown @command="handCommand">
                            <span class="el-dropdown-link">
                                <div class="languageImg">
                                    <img :src="$store.state.nowstrLanguage.icon" alt="">
                                </div>
                                Language
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="(item, index) in $store.state.LangTypeList" :command="item"
                                    :key="index">
                                    <div style="display: flex;align-items: center;">
                                        <img style="width: 20px;height: auto;margin-right: 10px;" :src="item.icon"
                                            alt="">
                                        <p>{{ item.label }}</p>
                                    </div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>

                </div>
            </div>
        </div>
        <el-drawer title="" :visible.sync="drawer" :direction="direction" :before-close="handleClose">
            <div class="menuBox">
                <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" @open="handleOpen"
                    @close="handlemenuClose" @select="handleSelect">
                    <template v-for="(item, index) in $store.state.menuData">
                        <el-menu-item v-if="item.child.length == 0" :index="item.link">
                            <router-link :to="item.link">
                                {{ item.name }}
                            </router-link>
                        </el-menu-item>
                        <el-submenu v-else :index="item.id">
                            <template slot="title">
                                <router-link :to="item.link">
                                    {{ item.name }}
                                </router-link>
                            </template>
                            <el-menu-item v-for="(e, i) in item.child" :index="e.link" :key="i">
                                <router-link :to="e.link">
                                    {{ e.name }}
                                </router-link>
                            </el-menu-item>
                        </el-submenu>
                    </template>
                </el-menu>
            </div>
        </el-drawer>
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <div class="footBox">
            <foot-box></foot-box>
        </div>
        <nav-box></nav-box>
        <el-dialog :visible.sync="dialogVisible" width="100%" top="0" :show-close="false" :before-close="handleClose">
            <div class="searchBoxH">
                <div class="icon" @click="searchInput">
                    <img src="../assets/home/search.png" alt="">
                </div>
                <input type="text" :placeholder="i18n.home.keyword" v-model="keyword" @keyup.enter="searchInput">
            </div>
        </el-dialog>
    </div>
</template>

<script>
import footBox from '@/components/footBox.vue';
import navBox from '@/components/navBox.vue'
export default {
    name: 'index',

    data() {
        return {
            detailTitle: '',
            detailId: '',
            activeIndex: "/",
            drawer: false,
            direction: 'rtl',
            keyword: '',
            dialogVisible: false,
            nowPage: ''
        };
    },
    components: { footBox, navBox },
    computed: {
        i18n() {
            return this.$t("message");
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                let p = route.path
                console.log(111, p, p.indexOf('/product/'))


                if (p.indexOf('/product/') != -1) {
                    if (route?.params?.id) {
                        this.detailId = route?.params?.id
                    } else {
                        this.detailTitle = route?.params?.type_title?.replaceAll('-', ' ') || ""
                        this.detailId = 0
                    }

                } else {
                    if (p.indexOf('/product') == -1) this.detailTitle = ''
                    if (p.indexOf('/product') == -1) this.detailId = 0
                }




                if (route.path == '/news/newsDetial') {
                    this.activeIndex = '/news';
                } else if (route.path.indexOf('product-detail') != -1) {

                    this.activeIndex = '/product';
                } else {
                    this.activeIndex = route.path; // 监听路由变化，更新激活项
                }
                this.nowPage = route.path;
            },
        },
    },
    methods: {
        // menu
        handleOpen(key, keyPath) {
            // console.log(key, keyPath);
        },
        handlemenuClose(key, keyPath) {
            // console.log(key, keyPath);
        },
        handleSelect() {
            this.drawer = false;
        },
        // 选择语言
        handCommand(e) {
            this.$store.state.nowstrLanguage = e;
            this.$store.state.nowLanguage = e.value;
            this._i18n.locale = String(this.$store.state.nowLanguage);
            localStorage.setItem("nowstrLanguage", JSON.stringify(this.$store.state.nowstrLanguage));
            localStorage.setItem("selLanguage", String(this.$store.state.nowLanguage));
            this.$forceUpdate();
        },
        // h5弹窗
        handleClose(done) {
            done();
        },
        searchInput() {
            this.$bus.$emit('search', this.keyword);
            this.keyword = '';
            this.dialogVisible = false;
        },
        // 返回主页
        goHome() {
            this.$router.push(`/`);
        }
    },
    beforeCreate() { },
    created() {

    },
    destroyed() { },
    beforeMount() { },
    mounted() {

    },
    beforeUpdate() { },
    updated() {
    },
    beforeDestroy() { },
    activated() { },
    deactivated() { },
};
</script>
<style lang="less" scoped>
//   ::v-deep .el-menu{
//       border: none;
//       height: 100px;
//       background: #1551D1;
//       // menu
//       .el-menu-item{
//           color: #FFFFFF;
//           height: 100px;
//           max-width: 150px;
//           line-height: 1;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           border: none;
//           font-size: 18px !important;
//           padding: 0;
//       }
//       a{
//         width: 100%;
//         height: 100%;
//         padding: 0 20px;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         white-space: normal;
//         text-align: center;
//       }
//       // 选中的menu
//       .is-active{
//           color: #1551D1 !important;
//           background: #FFFFFF !important;
//       }
//       .el-submenu{
//         .el-submenu__title{
//               color: #FFFFFF;
//               height: 100px;
//               line-height: 1;
//               display: flex;
//               align-items: center;
//               justify-content: center;
//               border: none; 
//               font-size: 18px !important;
//               background-color: none !important;
//               max-width: 150px;
//               &:hover{
//                 color: #1551D1 !important;
//                 a{
//                     color: #1551D1 !important;
//                 }
//               }
//               i{
//                 color: #FFFFFF;
//                 font-size: 20px;
//               }
//             a{
//                 color: #FFFFFF;
//             }
//         }
//       }
//       .is-active{
//           .el-submenu__title{
//               color: #1551D1 !important;
//               height: 100px;
//               line-height: 1;
//               display: flex;
//               align-items: center;
//               justify-content: center;
//               border: none;
//               background-color: #FFFFFF !important;
//               a{
//                 color: #1551D1;
//               }
//           }
//       }

//   }
//   .el-menu--horizontal .el-menu .el-menu-item{
//     height: 60px;
//     display: flex;
//     align-items: center;
//     font-size: 18px;
//   }
//   .el-menu--horizontal .el-menu .el-menu-item:hover{
//     background: #1551D1 !important;
//     color: #FFFFFF !important;
//     a{
//         color: #FFFFFF !important;
//     }
//   }
//   .el-menu--horizontal .el-menu .el-menu-item a{
//     color: #333333 !important;
//     width: 100%;
//     height: 100%;
//     display: flex;
//     align-items: center;
//   }
::v-deep .el-menu {
    border: none;
    height: 100px;
    background: none;

    //   background: #1551D1;
    // menu
    .el-menu-item {
        color: #FFFFFF;
        height: 100px;
        max-width: 250px;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        font-size: 22px !important;
        padding: 0;

        &:hover {
            background: none !important;
            color: #1551D1 !important;
        }
    }

    a {
        width: 100%;
        height: 100%;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: normal;
        text-align: center;
    }

    // 选中的menu
    .is-active {
        color: #1551D1 !important;
        background: none !important;
    }

    .el-submenu {
        .el-submenu__title {
            color: #FFFFFF;
            height: 100px;
            line-height: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
            font-size: 22px !important;
            background-color: none !important;
            max-width: 250px;

            &:hover {
                background: none !important;
                color: #1551D1 !important;

                a {
                    color: #1551D1 !important;
                }
            }

            i {
                color: #FFFFFF;
                font-size: 22px;
            }

            a {
                color: #FFFFFF;
            }
        }
    }

    .is-active {
        .el-submenu__title {
            color: #1551D1 !important;
            height: 100px;
            line-height: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
            background-color: none !important;

            a {
                color: #1551D1;
            }
        }
    }

    .router-link-active {
        color: #1551D1 !important;
    }
}

.el-menu--horizontal .el-menu .el-menu-item {
    height: 60px;
    display: flex;
    align-items: center;
    font-size: 22px;
}

.el-menu--horizontal .el-menu .el-menu-item:hover {
    background: #1551D1 !important;
    color: #FFFFFF !important;

    a {
        color: #FFFFFF !important;
    }
}

.el-menu--horizontal .el-menu .el-menu-item a {
    color: #333333 !important;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
}

.header {
    width: 100%;
}

.header2 {
    height: 180px;
}

.head2 {
    background: #000000 !important;
}

.head {
    height: 180px;
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
}

.headerH {
    display: none;
}

//   .headerTop{
//       width: 100%;
//       height: 80px;
//       padding: 0 250px;
//       box-sizing: border-box;
//       display: flex;
//       align-items: center;
//       justify-content: space-between;
//       background: #FFFFFF;
//       .logoBox{
//           display: flex;
//           align-items: center;
//           .logo{
//               width: 54px;
//               height: 54px;
//               img{
//                   width: 54px;
//                   height: 54px;
//               }
//           }
//           .logoText{
//               margin-left: 10px;
//               p{
//                   &:nth-child(1){
//                       font-size: 18px;
//                       color: #222222;
//                       font-weight: bold;
//                   }
//                   &:nth-child(2){
//                       font-size: 12px;
//                       color: #2C2C2C;
//                   }
//               }
//           }
//       }
//       .infoBox{
//           display: flex;
//           align-items: center;
//           .infoList{
//               display: flex;
//               align-items: center;
//               color: #333333;
//               margin-left: 60px;
//               .icon{
//                   width: 25px;
//                   height: 25px;
//                   margin-right: 10px;
//                   font-size: 18px;
//                   img{
//                       width: 25px;
//                       height: 25px;
//                   }
//               }
//           }
//           .languageBox{
//             margin-left: 50px;
//             .languageImg{
//                 width: 30px;
//                 height: 15px;
//                 margin-right: 10px;
//                 img{
//                     width: 30px;
//                     height: 15px;
//                 }
//             }
//             .el-dropdown-link{
//                 font-size: 18px;
//                 color: #333333;
//                 display: flex;
//                 align-items: center;
//             }
//           }
//       }
//   }
.headerTop {
    width: 100%;
    height: 80px;
    padding: 0 250px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    // background: #FFFFFF;
    .logoBox {
        display: flex;
        align-items: center;
        cursor: pointer;

        .logo {
            width: 60px;
            height: 60px;

            img {
                width: 60px;
                height: 60px;
            }
        }

        .logoText {
            margin-left: 10px;

            p {
                &:nth-child(1) {
                    font-size: 20px;
                    color: #FFFFFF;
                    font-weight: bold;
                }

                &:nth-child(2) {
                    font-size: 20px;
                    color: #FFFFFF;
                }
            }

            img {
                width: 200px;
                height: auto;
            }
        }
    }

    .infoBox {
        display: flex;
        align-items: center;

        .infoList {
            display: flex;
            align-items: center;
            color: #FFFFFF;
            margin-left: 60px;

            a {
                color: #FFFFFF;
                font-size: 20px;
            }

            .icon {
                width: 25px;
                height: 25px;
                margin-right: 10px;
                font-size: 20px;

                img {
                    width: 25px;
                    height: 25px;
                }
            }
        }

        .languageBox {
            margin-left: 50px;

            .languageImg {
                width: 30px;
                height: 15px;
                margin-right: 10px;

                img {
                    width: 30px;
                    height: 15px;
                }
            }

            .el-dropdown-link {
                font-size: 20px;
                color: #FFFFFF;
                display: flex;
                align-items: center;
            }
        }
    }
}

.menuBox {
    width: 100%;
    height: 100px;
    padding: 0 250px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    //   background: #1551D1;
    .searchBox {
        width: 286px;
        height: 46px;
        border-radius: 129px;
        padding: 0 15px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        // background: #2268EB;
        border: 1px solid #FFFFFF;

        .icon {
            width: 24px;
            height: 24px;

            img {
                width: 24px;
                height: 24px;
            }
        }

        input {
            background: none;
            margin-left: 10px;
            color: #FFFFFF;
            font-size: 20px;
        }

        input::placeholder {
            color: #FFFFFF;
            font-size: 20px;
        }
    }
}

.searchBoxH {
    width: 100%;
    height: 80px;
    border-radius: 20px;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border: 1px solid #2268EB;

    .icon {
        width: 24px;
        height: 24px;

        img {
            width: 24px;
            height: 24px;
        }
    }

    input {
        width: 100%;
        background: none;
        color: #2268EB;
        font-size: 30px;
    }

    input::placeholder {
        color: #2268EB;
        font-size: 30px;
    }
}

//   .menuBox{
//       width: 100%;
//       height: 100px;
//       padding: 0 250px;
//       box-sizing: border-box;
//       display: flex;
//       align-items: center;
//       justify-content: space-between;
//       background: #1551D1;
//       .searchBox{
//           width: 286px;
//           height: 46px;
//           border-radius: 129px;
//           padding: 0 15px;
//           box-sizing: border-box;
//           display: flex;
//           align-items: center;
//           background: #2268EB;
//           .icon{
//               width: 24px;
//               height: 24px;
//               img{
//                   width: 24px;
//                   height: 24px;
//               }
//           }
//           input{
//               background: none;
//               margin-left: 10px;
//               color: #FFFFFF;
//               font-size: 18px;
//           }
//           input::placeholder {
//               color: #FFFFFF;
//               font-size: 18px;
//           }
//       }
//   }
//   .searchBoxH{
//     width: 100%;
//     height: 80px;
//     border-radius: 20px;
//     padding: 0 15px;
//     box-sizing: border-box;
//     display: flex;
//     align-items: center;
//     border:1px solid #2268EB;
//     .icon{
//         width: 24px;
//         height: 24px;
//         img{
//             width: 24px;
//             height: 24px;
//         }
//     }
//     input{
//         width: 100%;
//         background: none;
//         color: #2268EB;
//         font-size: 30px;
//     }
//     input::placeholder {
//         color: #2268EB;
//         font-size: 30px;
//     }
//   }
@media screen and (max-width: 1600px) {
    .headerTop {
        padding: 0 150px;
    }

    .menuBox {
        padding: 0 150px;
    }
}

@media screen and (max-width: 1024px) {
    .header {
        display: none;
    }

    .headerH {
        display: block;
    }

    .headH {
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        padding: 10px 30px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: rgba(17, 20, 22, .8);
    }

    .logoBox {
        display: flex;
        align-items: center;

        .logo {
            width: 70px;
            height: 70px;

            img {
                width: 70px;
                height: 70px;
            }
        }

        .logoText {
            margin-left: 10px;

            p {
                &:nth-child(1) {
                    font-size: 22px;
                    color: #FFFFFF;
                    font-weight: bold;
                }

                &:nth-child(2) {
                    font-size: 18px;
                    color: #FFFFFF;
                }
            }

            img {
                width: 200px;
                height: auto;
            }
        }
    }

    .searchmenu {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .searchBox {
            width: 40px;
            height: 40px;

            img {
                width: 40px;
                height: 40px;
            }
        }

        .menuIcon {
            margin-left: 10px;

            ::v-deep .el-icon-s-operation {
                &::before {
                    font-size: 40px;
                    color: #FFFFFF;
                }
            }

            ::v-deep .el-icon-s-unfold {
                &::before {
                    font-size: 40px;
                    color: #FFFFFF;
                }
            }
        }
    }

    .languageBox {
        margin-top: 10px;

        .languageImg {
            width: 50px;
            height: auto;
            margin-right: 10px;

            img {
                width: 50px;
                height: auto;
            }
        }

        .el-dropdown-link {
            font-size: 24px;
            color: #FFFFFF;
            display: flex;
            align-items: center;
        }
    }

    ::v-deep .el-drawer {
        width: 50% !important;
    }

    .menuBox {
        width: 100%;
        height: 100vh;
        padding: 0 30px;
        box-sizing: border-box;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        background: #FFFFFF;

        ::v-deep .el-menu {
            width: 100%;
            border: none;
            background: #FFFFFF;

            // menu
            .el-menu-item {
                color: #FFFFFF;
                height: 100px;
                line-height: 1;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                border: none;
                font-size: 24px !important;
                padding: 0 !important;
                text-align: left;
                max-width: 100%;

                &:hover {
                    background: none !important;
                }
            }

            a {
                width: 100%;
                height: 100%;
                padding: 0 10px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
            }

            // 选中的menu
            .is-active {
                color: #1551D1;
                background: #FFFFFF !important;

                a {
                    width: 100%;
                    height: 100%;
                    padding: 0 10px;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    color: #1551D1;
                }
            }

            .el-submenu {
                width: 100%;

                .el-submenu__title {
                    color: #333333;
                    height: 100px;
                    line-height: 1;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start !important;
                    border: none;
                    font-size: 24px !important;
                    background-color: none !important;
                    padding: 0 !important;
                    text-align: left;
                    max-width: 100%;

                    &:hover {
                        background: none !important;
                    }
                }

                .el-menu-item {
                    color: #333333;
                }

                a {
                    color: #333333;
                }

                .is-active {
                    a {
                        color: #1551D1;
                    }
                }

                .el-menu {
                    height: auto;
                    border: 1px solid rgba(21, 81, 209, .3);
                    border-radius: 10px;
                }
            }

            .is-opened {
                .el-submenu__title {
                    width: 100%;
                    color: #333333 !important;
                    background: none !important;
                }
            }

            .is-active {
                .el-submenu__title {
                    color: #1551D1;
                    height: 100px;
                    line-height: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: none;
                    background-color: #FFFFFF !important;
                }
            }

            .el-menu--horizontal {

                // display: block !important;
                .el-menu-item {
                    background: #FFFFFF;
                }
            }
        }
    }
}

.el-menu--horizontal .el-menu .el-menu-item .active2025 {
    background: #1551D1 !important;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    padding: 0 0.625rem;
    box-sizing: border-box;

    a {
        color: #FFFFFF !important;
    }


}
</style>